const accessibilityBlocks = document.querySelectorAll('.accessibility-block');

accessibilityBlocks.forEach((block) => {
  const fontSizeButtons = block.querySelectorAll('.font-size-btn');
  const toggleContrastButton = block.querySelector(
    '.accessibility-block__toggle-contrast'
  );
  const toggleReadabilityButton = block.querySelector(
    '.accessibility-block__toggle-readability'
  );
  const toggleContrastSwitch = block.querySelector('#contrast-toggle-mobile');

  const elementsWithFontSize = [];

  const fontSizes = {
    small: 0,
    medium: 1,
    large: 3,
  };

  function storeInitialFontSizes() {
    const allElements = document.querySelectorAll('*');
    allElements.forEach((element) => {
      const computedStyle = window.getComputedStyle(element);
      const fontSize = parseFloat(computedStyle.fontSize);

      elementsWithFontSize.push({
        element: element,
        initialFontSize: fontSize,
      });
    });
  }

  function applyFontSize(sizeKey) {
    const increase = fontSizes[sizeKey];

    if (sizeKey === 'small') {
      elementsWithFontSize.forEach((item) => {
        item.element.style.fontSize = '';
      });
      localStorage.removeItem('font-size-key');
    } else {
      elementsWithFontSize.forEach((item) => {
        // Pomiń pierwszy link w .yoast-breadcrumbs
        const isYoastBreadcrumbFirstLink =
          item.element.tagName === 'A' &&
          item.element ===
            item.element
              .closest('.yoast-breadcrumbs')
              ?.querySelector('a:first-of-type');

        if (isYoastBreadcrumbFirstLink) return;

        item.element.style.setProperty(
          'font-size',
          item.initialFontSize + increase + 'px',
          'important'
        );
      });
      localStorage.setItem('font-size-key', sizeKey);
    }
  }

  function loadAccessibilitySettings() {
    const savedFontSize = localStorage.getItem('font-size-key');
    if (savedFontSize && savedFontSize !== 'small') {
      applyFontSize(savedFontSize);
    }

    fontSizeButtons.forEach((btn) => {
      btn.classList.remove('active');
      if (btn.dataset.size === savedFontSize) {
        btn.classList.add('active');
      }
    });

    if (!savedFontSize || savedFontSize === 'small') {
      fontSizeButtons[0]?.classList.add('active');
    }

    if (localStorage.getItem('contrast-mode')) {
      document.body.classList.add('contrast-mode');
      toggleContrastButton?.setAttribute('aria-pressed', 'true');
      toggleContrastSwitch.checked = true;
    }

    if (localStorage.getItem('readability-mode')) {
      document.body.classList.add('readability-mode');
      toggleReadabilityButton?.setAttribute('aria-pressed', 'true');
    }
  }

  function toggleContrast() {
    const isActive = document.body.classList.toggle('contrast-mode');
    toggleContrastButton?.setAttribute('aria-pressed', isActive.toString());
    isActive
      ? localStorage.setItem('contrast-mode', true)
      : localStorage.removeItem('contrast-mode');
  }

  function toggleReadability() {
    const isActive = document.body.classList.toggle('readability-mode');
    toggleReadabilityButton?.setAttribute('aria-pressed', isActive.toString());
    isActive
      ? localStorage.setItem('readability-mode', true)
      : localStorage.removeItem('readability-mode');
  }

  storeInitialFontSizes();
  loadAccessibilitySettings();

  fontSizeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const sizeKey = btn.dataset.size;
      applyFontSize(sizeKey);

      fontSizeButtons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  toggleContrastButton?.addEventListener('click', toggleContrast);
  toggleContrastSwitch?.addEventListener('change', () => {
    toggleContrast();
  });
  toggleReadabilityButton?.addEventListener('click', toggleReadability);
});
